import React, { useState, useEffect, useRef } from "react";
import ReactHtmlParser from 'react-html-parser';
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";

import cartImg3 from "../../assets/svgs/my-cart.svg";


import "./orderItem.css";
import "./button.css";
import "../../assets/css/modal.css";
import "../../assets/css/form.css"
import thumb4 from "../../assets/images/thumb4.png";
// import { addTocart, cartLocal, getProductVariation } from "../../actions/productActions";
import { cartLocal, getProductVariation } from "../../actions/productActions";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { text } from "dom-helpers";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ComboProductList from "./ComboProduct/comboProductList";
import ModalCloseButton from "../ModalCloseButton/ModalCloseButton";

const ChooseModal = (props) => {
  const { replaceContext } = props;
  const isReplaceMode = Boolean(replaceContext);
  const [price, setPrice] = useState(0);
  const [variation_set_id, setvariationSetId] = useState([]);
  const [variation, setvariation] = useState([]);
  const [variation_name, setvariationName] = useState([]);
  const [variation_quantity, setvariationQuantity] = useState([]);
  const [variation_price, setvariationPrice] = useState([]);
  const [load, setload] = useState(false);
  const [addCart, setaddCart] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const [productId, setProductId] = useState(0);
  // const [productVariation, setProductVariation] = useState(null);
  // const [productVariationLoad, setProductVariationLoad] = useState(false);
  const [cartData, setCartData] = useState(null);
  const [notifyAtLeast, setNotifyAtLeast] = useState("");
  const [checkFlag, setCheckFlag] = useState("");
  const [zeroModifiers, setZeroModifiers] = useState([]);
  const [comboModifierPrice, setComboModifierPrice] = useState(0);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorComboIds, setErrorComboIds] = useState([]);
  const [variationQty, setVariationQty] = useState({});
  const [modifierErrors, setModifierErrors] = useState({});
  let product = props.product;
  let show = props.show;



  useEffect(() => {
    if (props.show && product && product.id !== productId) {
      props.getProductVariation(product.id);
      setProductId(product.id);
    }
  }, [props.show, product, productId, props.getProductVariation]);

  useEffect(() => {
    if (!props.show) {
      setProductId(0);
    }
  }, [props.show]);

  // Sync with localStorage when modal opens so only it takes the cuurent cart icon

  useEffect(() => {
    if (props.show) {
      const headerCart = props.cartData || JSON.parse(localStorage.getItem("cart")) || [];
      setCartData(headerCart);
      setErrorMessage("");
      setErrorComboIds([]);
      setZeroModifiers([]);
      setVariationQty({});
      setModifierErrors({});
      setvariation([]);
      setvariationName([]);
      setvariationQuantity([]);
      setvariationSetId([]);
      setvariationPrice([]);
      setPrice(0);
    }
  }, [props.show, props.cartData, product?.id]);

  useEffect(() => {
    if (props.show) {
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = ""
    }
  }, [props.show, props.loading])

  useEffect(() => {
    renderVariation()
  }, [checkFlag])

  useEffect(() => {
    // if (
    //   load &&
    //   !props.loading &&
    //   props.add_to_cart !== null &&
    //   props.add_to_cart.data &&
    //   Object.keys(props.add_to_cart.data).length > 0
    // ) {
    //   // console.log('_____Choose model update cart_________');
    //   props.updateCart(props.add_to_cart.data);
    //   let data = {
    //     cart_id: props.add_to_cart.data.cart[0].id,
    //   };
    //   props.setOrder(data);
    //   // props.showPickupModal();
    //   setload(false);
    //   props.setLshow(true);

    //   props.closeModal();
    //   setPrice(0);
    //   setQuantity(1);
    //   setvariation([]);
    //   // console.log('_____C_________');
    // }

    if (
      load &&
      !props.loading &&
      cartData !== null &&
      Object.keys(cartData).length > 0
    ) {
      props.updateCart(cartData);
      // props.showPickupModal();
      setload(false);
      // props.setLshow(true);

      props.closeModal();
      setPrice(0);
      setQuantity(1);
      setvariation([]);
      setvariationName([]);
      setvariationQuantity([]);
      setvariationSetId([]);
      setvariationPrice([]);
      setNotifyAtLeast("");
      // console.log('_____C_________');
    }

    // console.log(props);
    // localStorage.removeItem("cart");
    // console.log(JSON.parse(localStorage.getItem("cart")));
    // console.log(props);

  }, [addCart, load, props, cartData]);

  const selectVariation = (e, id, name, newprice, setid) => {
    if (e.target.checked) {
      let sprice = price + newprice;
      setPrice(sprice);
      setvariation([...variation, id]);
      setvariationName([...variation_name, name]);
      setvariationQuantity([...variation_quantity, 1]);
      setvariationSetId([...variation_set_id, setid]);
      setvariationPrice([...variation_price, newprice]);
      setCheckFlag(true) //here
      setErrorMessage("");
    } else {
      let sprice = price - newprice;
      setPrice(sprice);
      var varIndex = variation.indexOf(id);
      variation.splice(varIndex, 1);
      setvariation(variation);

      // var varNameIndex = variation_name.indexOf(name);
      variation_name.splice(varIndex, 1);
      setvariationName(variation_name);

      variation_quantity.splice(varIndex, 1);
      setvariationQuantity(variation_quantity);

      // var varSetIdIndex = variation_set_id.indexOf(setid);
      variation_set_id.splice(varIndex, 1);
      setvariationSetId(variation_set_id);

      variation_price.splice(varIndex, 1)
      setvariationPrice(variation_price)
      setCheckFlag(false) //here
    }
  };

  const renderVariation = () => {
    if (props.variation == null) return null;
    const filteredVariation = props.variation.filter(v => v.not_for_pickup_delivery !== 1);
    if (!filteredVariation || filteredVariation.length === 0) return null;

    return filteredVariation.map((vari) => {
      const at_least_sentence = vari.order_limit_at_least > 0 ? `Min ${vari.order_limit_at_least} required` : "";
      const currentSetQty = Object.entries(variationQty)
        .filter(([key]) => vari.value.some(v => v.id === Number(key)))
        .reduce((sum, [, qty]) => sum + qty, 0);

      const maxLimit = vari.order_limit || 0;
      const minLimit = vari.order_limit_at_least || 0;

      const minDisplay = Math.min(currentSetQty, minLimit);
      const checkedValuesID = Array.isArray(variation) ? variation : [];
      let checkedCount = Object.entries(variationQty)
        .filter(([key]) => vari.value.some(v => v.id === Number(key)))
        .reduce((sum, [, qty]) => sum + qty, 0);
      const options = Object.values(vari.value).filter(iv => iv.not_for_delivery !== 1 && iv.not_for_selling !== 1);
      if (options.length === 0) return null;

      return (
        <div className="cm-group" key={vari.id}>
          <div className="cm-group-header">
            <span className="cm-group-name">{vari.name}</span>
                {modifierErrors[vari.id] && (
                  <div className="cm-modifier-error">
                    {modifierErrors[vari.id]}
                  </div>
                )}
                        {(maxLimit || minLimit) ? (
            <span className="cm-group-badge">
              {maxLimit ? `Max ${currentSetQty}/${maxLimit}` : ""}
              {minLimit ? ` (Min ${minDisplay}/${minLimit})` : ""}
            </span>
            ) : null}
          </div>
          {options.map((innerVari) => {
            const qty = variationQty[innerVari.id] || 0;
            const isOutOfStock = innerVari.out_of_stock === 1;
            return (
              <div
                key={innerVari.id}
                className={`cm-option${isOutOfStock ? ' disabled' : ''}`}
              >
                <div className="cm-option-left">
                  <span className="cm-option-name">{innerVari.name}</span>
                  {isOutOfStock && (<span className="cm-option-out-of-stock">Out of stock</span>
                  )}
                </div>
                <div className="qty-control">
                  <button
                    className="qty-btn"
                    disabled={qty <= 0}
                    onClick={(e) => {
                      e.stopPropagation();
                      decreaseVariationQty(innerVari);
                    }}
                  >
                    -
                  </button>
                  <span className="qty-value">{qty}</span>
                  <button
                    className="qty-btn plus"
                    disabled={isOutOfStock}
                    onClick={(e) => {
                      e.stopPropagation();
                      increaseVariationQty(innerVari, vari);
                    }}
                  >
                    +
                  </button>
                </div>
                <span className="cm-option-price">+${parseFloat(innerVari.sell_price_inc_tax).toFixed(2)}</span>
              </div>
            );
          })}
        </div>
      );
    });
  };
  const increaseVariationQty = (innerVari, vari) => {
    const modifierLimit = innerVari.modifier_order_limit || Infinity;
    const setLimit = vari.order_limit || Infinity;
setModifierErrors(prev => {
  const updated = { ...prev };
  delete updated[vari.id];
  return updated;
});
    setVariationQty(prev => {

      const currentQty = prev[innerVari.id] || 0;
      const totalSetQty = Object.entries(prev)
        .filter(([key]) => {
          const id = Number(key);
          return vari.value.some(v => v.id === id);
        })
        .reduce((sum, [, qty]) => sum + qty, 0);


      if (currentQty >= modifierLimit) {
  setModifierErrors(prev => ({
    ...prev,
    [vari.id]: `Maximum ${modifierLimit} allowed for ${innerVari.name}`
  }));
  return prev;
}

if (totalSetQty >= setLimit) {
  setModifierErrors(prev => ({
    ...prev,
    [vari.id]: `Maximum ${setLimit} selections allowed`
  }));
  return prev;
}

      const newQty = currentQty + 1;

      if (!variation.includes(innerVari.id)) {
        setvariation([...variation, innerVari.id]);
        setvariationName([...variation_name, innerVari.name]);
        setvariationQuantity([...variation_quantity, newQty]);
        setvariationSetId([...variation_set_id, vari.id]);
        setvariationPrice([...variation_price, parseFloat(innerVari.sell_price_inc_tax)]);
      } else {
        const idx = variation.indexOf(innerVari.id);
        const updatedQty = [...variation_quantity];
        updatedQty[idx] = newQty;
        setvariationQuantity(updatedQty);
      }

      setPrice(prevPrice => prevPrice + parseFloat(innerVari.sell_price_inc_tax));

      return {
        ...prev,
        [innerVari.id]: newQty
      };
    });
  };
  const decreaseVariationQty = (innerVari) => {
    setModifierErrors({});
    setVariationQty(prev => {
      const currentQty = prev[innerVari.id] || 0;

      if (currentQty <= 0) return prev;

      const newQty = currentQty - 1;

      setPrice(prevPrice => prevPrice - parseFloat(innerVari.sell_price_inc_tax));

      if (newQty === 0) {
        const idx = variation.indexOf(innerVari.id);
        setvariation(variation.filter(id => id !== innerVari.id));
        setvariationName(variation_name.filter((_, i) => i !== idx));
        setvariationQuantity(variation_quantity.filter((_, i) => i !== idx));
        setvariationSetId(variation_set_id.filter((_, i) => i !== idx));
        setvariationPrice(variation_price.filter((_, i) => i !== idx));

        return Object.fromEntries(
          Object.entries(prev).filter(([key]) => Number(key) !== innerVari.id)
        );
      } else {
        const idx = variation.indexOf(innerVari.id);
        if (idx !== -1) {
          const updatedQty = [...variation_quantity];
          updatedQty[idx] = newQty;
          setvariationQuantity(updatedQty);
        }
      }

      return {
        ...prev,
        [innerVari.id]: newQty
      };
    });
  };
  const addCartLocal = (data) => {
    if (isReplaceMode) {
      const cart = JSON.parse(localStorage.getItem("cart")) || [];
      console.log("Cart from localStorage:", cart);

      const index = cart.findIndex(
        (i) => i.id === replaceContext.cartItemId
      );
      if (index === -1) return;
      console.log("Index of item to replace:", index);
      const item = { ...cart[index] };
      console.log("Item before replacement:", item);

      // ---- normalize ----
      const qty = Number(item.quantity) || 1;
      const basePrice = Number(item.product_price) || 0;

      const ids = String(item.variation_id || "").split(",").filter(Boolean);
      const names = String(item.variation_name || "").split(",").filter(Boolean);

      let prices = [];
      if (Array.isArray(item.variation_price)) {
        prices = item.variation_price.map(p => Number(p) || 0);
      } else if (typeof item.variation_price === "string") {
        prices = item.variation_price.split(",").map(p => Number(p) || 0);
      } else {
        prices = new Array(ids.length).fill(0);
      }
      console.log("Normalized variations:", { ids, names, prices });

      // ---- apply replace ----
      ids[replaceContext.replaceIndex] = String(variation[0]);
      names[replaceContext.replaceIndex] = variation_name[0];
      prices[replaceContext.replaceIndex] = Number(variation_price[0]) || 0;

      const modifierTotal = prices.reduce((s, p) => s + p, 0);

      item.variation_id = ids.join(",");
      item.variation_name = names.join(",");
      item.variation_price = prices;
      item.vari_price = modifierTotal;

      item.price = qty * (basePrice + modifierTotal);
      item.product_name = replaceContext.product.name;
      console.log("Item after replacement:", item);
      cart[index] = item;

      localStorage.setItem("cart", JSON.stringify(cart));
      console.log("Updated cart saved to localStorage:", cart);

      props.cartLocal(cart);

      props.closeModal();

      setvariation([]);
      setvariationName([]);
      setvariationPrice([]);
      setPrice(0);

      return;
    }
    var b = [];

    b = JSON.parse(localStorage.getItem("cart")) || [];

    const existingIndex = b.findIndex((item) => {
      return (
        item.product_id === data.product_id &&
        item.variation_id === data.variation_id &&
        JSON.stringify(item.combo_products_set || []) === JSON.stringify(data.combo_products_set || [])
      );
    });

    if (existingIndex !== -1) {
      // ------------------Product With Amount---------------------//
      b[existingIndex].quantity += data.quantity;
      b[existingIndex].price += data.price;

    } else {
      b.push(data);
    }
    localStorage.setItem("cart", JSON.stringify(b));

    // props.cartLocal(b);
    setCartData(JSON.parse(localStorage.getItem("cart")));
    props.cartLocal(b); // update redux store or header
  };

  // response = await response.map((item, index) => {
  //   return(
  //   {
  //     id:item.id,
  //     type:item.name,
  //     maxSelect:0,
  //     items: item.value.map((innerItem, innerIndex) => {
  //       return(
  //       {
  //         id:innerItem.id, //variation_id
  //         name:innerItem.name,
  //         price: innerItem.default_sell_price,
  //         set_id: item.id,
  //         hide_on_receipt: item.not_for_receipt
  //       });
  //     })
  //   });
  // })


  const imgRefs = useRef({});     // store modal image refs
  const modalBodyRef = useRef(null);

  // Bring the validation error into view: the first flagged combo item if any,
  // otherwise the error banner at the top of the modal body.
  const scrollToError = () => {
    requestAnimationFrame(() => {
      const body = modalBodyRef.current;
      if (!body) return;
      const comboError = body.querySelector(".combo-error-text");
      if (comboError) {
        comboError.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }
      body.scrollTo({ top: 0, behavior: "smooth" });
      const modalEl = body.closest(".modal");
      if (modalEl) modalEl.scrollTo({ top: 0, behavior: "smooth" });
    });
  };


  const addTocarts = () => {
    // --------- COMBO PRODUCT VALIDATION ----------
    // Ensure we have the combo data for the CURRENT product
    const comboResponse = props.combo_products?.[0];
    const isCorrectProduct = comboResponse && (Number(comboResponse.id) === Number(product.id) || Number(comboResponse.combo_base_product_id) === Number(product.id));

    const comboList = (isCorrectProduct && comboResponse?.combo_products) ? comboResponse.combo_products.filter(
      item => Number(item.not_for_selling) !== 1 && Number(item.not_for_pickup_delivery) !== 1
    ) : [];

    console.log("Combo Validation Start:", {
      currentProductId: product.id,
      reduxComboId: comboResponse?.id || comboResponse?.combo_base_product_id,
      isCorrectProduct,
      comboListLength: comboList.length,
      productHasComboItems: !!product.combo_products?.length
    });

    if (product.combo_products && product.combo_products.length > 0) {
      if (comboList.length === 0) {
        console.warn("Validation skipped: comboList is empty. Stale data or loading?");
        setErrorMessage("Loading choices, please wait a moment...");
        scrollToError();
        return;
      }

      const missingRequiredCombos = [];

      for (const combo of comboList) {
        const groups = combo?.combo_product_modifiers_id || [];
        let hasUnfulfilledModifier = false;

        console.log(`Checking combo item: ${combo.name}`, { groupsCount: groups.length });

        for (const group of groups) {
          for (const modifierSet of (group.modifier || [])) {
            const minRequired = Number(modifierSet.order_limit_at_least || 0);
            if (minRequired === 0) continue;
            if (Number(modifierSet.not_for_digital_ordering) === 1) continue;

            const visibleItems = modifierSet.modifier_details || [];

            if (visibleItems.length === 0) {
              console.log(`- Skipping set ${modifierSet.name}: no items available`);
              continue;
            }

            const visibleItemIds = visibleItems.map(item => Number(item.id));
            const currentModifiers = Array.isArray(zeroModifiers) ? zeroModifiers : [];
            const selectedCount = currentModifiers
              .filter(mod =>
                visibleItemIds.includes(Number(mod.id)) &&
                Number(mod.base_product_id) === Number(combo.id)
              )
              .reduce((sum, mod) => sum + (mod.qty || 1), 0);

            console.log(`- Set: ${modifierSet.name}, Required: ${minRequired}, Found: ${selectedCount}`);

            if (selectedCount < minRequired) {
              hasUnfulfilledModifier = true;
              break;
            }
          }
          if (hasUnfulfilledModifier) break;
        }

        if (hasUnfulfilledModifier) {
          missingRequiredCombos.push(combo);
        }
      }

      if (missingRequiredCombos.length > 0) {
        const missingNames = missingRequiredCombos.map(c => c.name).join(", ");
        const missingIds = missingRequiredCombos.map(c => c.id);
        console.log("Validation Failed for:", missingNames);
        setErrorMessage(`Please choose modifiers for: ${missingNames}`);
        setErrorComboIds(missingIds);
        scrollToError();
        return;
      }
    }
    // --- Filter variations that can be ordered ---
    let filteredVariationData = [];
    if (props.variation && Array.isArray(props.variation)) {
      filteredVariationData = props.variation.filter(
        (variation) => variation.not_for_digital_ordering !== 1
      );
    }
    // --- Validation: Check minimum selection per variation ---
    for (let i = 0; i < filteredVariationData.length; i++) {
      const vari = filteredVariationData[i];
      const visibleItems = Object.values(vari.value || {}).filter(
        (item) =>
          item.not_for_selling !== 1 &&
          item.not_for_delivery !== 1
      );

      // If modifier set is completely invisible → skip validation
      if (visibleItems.length === 0) {
        continue;
      }
      let totalQty = Object.entries(variationQty)
        .filter(([key]) => vari.value.some(v => v.id === Number(key)))
        .reduce((sum, [, qty]) => sum + qty, 0);

      if (vari.order_limit_at_least !== 0 && totalQty < vari.order_limit_at_least) {
        setErrorMessage(`Please choose at least ${vari.order_limit_at_least} in ${vari.name}.`);
        scrollToError();
        return;
      }
    }

    let cartID;
    if (localStorage.cartID) {
      cartID = parseFloat(localStorage.getItem("cartID")) || 0;
      cartID += 1;
      localStorage.setItem("cartID", cartID);
    } else {
      cartID = 1; // first cart item
      localStorage.setItem("cartID", cartID);
    }

    let data = {
      ...product,
      id: cartID,
      product_id: product.id,
      product_name: product.name,
      product_variation_id: product.variation_id,//(product.variation_id).toString(),
      product_price: product.price,
      quantity: quantity,
      variation_id: variation && variation.length > 0 ? variation.join() : (product.variation_id).toString(),
      variation_name: variation_name.join(),
      variation_quantity: variation_quantity.join(),
      variation_set_id: variation_set_id.join(),
      price: quantity * (parseFloat(product.price) + price + (totalModifierPrice || 0)),
      vari_price: price,
      variation_price: variation_price,
      printed: 0,
      combo_products_set: zeroModifiers
    };

    setload(true);
    addCartLocal(data);

    // --- Fly image to header cart ---
    const imgOriginal = imgRefs.current[props.product.id];
    if (window.flyToCart && imgOriginal) {
      window.flyToCart({ current: imgOriginal });
    }


    props.closeModal();
    setPrice(0);
    setQuantity(1);
    setvariation([]);
    setvariationName([]);
    setvariationQuantity([]);
    setvariationSetId([]);
    setvariationPrice([]);
    setNotifyAtLeast("");
    setComboModifierPrice(0);
    setZeroModifiers([]);
  };
  const changeQty = (status) => {
    // console.log(status);
    let oldQty = quantity;
    if (status) {
      oldQty = oldQty + 1;
    } else {
      oldQty = oldQty - 1;
    }
    if (oldQty > 0) {
      setQuantity(oldQty);
    }
  };
  const closeModel = () => {
    if (!props.loading) {
      setPrice(0);
      setQuantity(1);
      setvariation([]);
      setvariationName([]);
      setvariationQuantity([]);
      setvariationSetId([]);
      setvariationPrice([]);
      setNotifyAtLeast("");
      setComboModifierPrice(0);
      setZeroModifiers([]);
      setErrorMessage("");
      setProductId(0);
      props.closeModal();
    }
  };

  const totalModifierPrice = Array.isArray(zeroModifiers)
    ? zeroModifiers.reduce((sum, item) => {
      const price = parseFloat(item.sell_price_inc_tax) || 0;
      return sum + price * (item.qty ?? 1);
    }, 0)
    : 0;

  if (!product) return null;
  return (
    <Modal
      show={show}
      onHide={closeModel}
      dialogClassName="modal-md choose-modal"
      centered
    >
      <ModalCloseButton onClick={closeModel} />
      <Modal.Header>
        <Modal.Title>Choose your option</Modal.Title>
      </Modal.Header>

      <Modal.Body ref={modalBodyRef}>
        {notifyAtLeast ? (
          <div style={{ padding: '8px 24px 0', color: '#e01e26', fontWeight: 600, fontSize: 13 }}>{notifyAtLeast}</div>
        ) : null}

        {errorMessage && errorComboIds.length === 0 ? (
          <div className="cm-error-message" style={{ padding: '8px 24px 0', color: '#e01e26', fontWeight: 600, fontSize: 13 }}>
            {errorMessage}
          </div>
        ) : null}

        {/* Product Strip */}
        <div className="cm-product-strip">
          <div className="cm-product-img">
            <img
              ref={(el) => (imgRefs.current[product.id] = el)}
              src={product.image || '/images/default_placeholder.png'}
              onError={(e) => { e.target.onerror = null; e.target.src = '/images/default_placeholder.png'; }}
              alt={product.name}
            />
          </div>
          <div className="cm-product-meta">
            <p className="cm-product-name">{product.name}</p>
            {product.product_description && (
              <p className="cm-product-desc">{ReactHtmlParser(product.product_description)}</p>
            )}
            <span className="cm-product-price">$ {parseFloat(product.price).toFixed(2)}</span>
          </div>
        </div>

        {/* Modifiers / Variations */}
        <div className="cm-modifiers">
          {product.combo_products && product.combo_products.length ? (
            <ComboProductList
              comboProductsId={product.id}
              errorComboIds={errorComboIds}
              onZeroModifierData={(data) => {
                setErrorMessage("");
                setErrorComboIds(prev => prev.filter(id => Number(id) !== Number(data.productId)));
                setZeroModifiers(prev => {
                  const prevArray = Array.isArray(prev) ? prev : [];
                  const filtered = prevArray.filter(m => Number(m.base_product_id) !== Number(data.productId));
                  return [...filtered, ...(data.modifiers || [])];
                });
              }}
              onModifierPrice={(p) => setComboModifierPrice(p || 0)}
            />
          ) : null}
          {renderVariation()}
        </div>
      </Modal.Body>

      <Modal.Footer>
        <div className="cm-footer">
          <div className="cm-qty-selector">
            <button
              className="cm-qty-btn"
              disabled={quantity <= 1}
              onClick={() => changeQty(false)}
            >−</button>
            <span className="cm-qty-value">{quantity}</span>
            <button
              className="cm-qty-btn"
              onClick={() => changeQty(true)}
            >+</button>
          </div>
          <button
            className="cm-add-btn"
            disabled={props.cashregister && props.cashregister.status === "closed"}
            onClick={addTocarts}
            data-testid={`${product.id}_add`}
          >
            <span className="btn-label">Add to cart</span>
            <span className="btn-price">$ {(quantity * (parseFloat(product.price) + price + (totalModifierPrice || 0))).toFixed(2)}</span>
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

ChooseModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  showPickupModal: PropTypes.func.isRequired,
  cartLocal: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  cartData: state.products.cart,
  add_to_cart: state.products.add_to_cart,
  loading: state.products.loading,
  variation: state.products.variation,
  combo_products: state.products.combo_products
});
export default withTranslation()(
  // connect(mapStateToProps, { addTocart, cartLocal, getProductVariation })(ChooseModal)
  connect(mapStateToProps, { cartLocal, getProductVariation })(ChooseModal)
);
